// extracted by mini-css-extract-plugin
export default {"text":"text--kOE6W","blink":"blink--Yb0fV"};